// Module
var code = "<label data-bind=\"text: $parent.GetValue(Name)\"></label>";
// Exports
export default code;